module.exports = __webpack_public_path__ + "img/feature-toolbar.96289bc1.png";